import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import {
  Container,
  Paper,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TablePagination,
  Radio,
  RadioGroup,
  FormControlLabel
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Serverurl from "./Apiurl";
export default class PaymentOutReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),
      projectId: "",
      vendorId: "",
      vendorType: "1",
	  status: "",
	  ts_status:"",
      selectedProject: "",
      selectedVendor: "",
openExportDialog: false,
      projectarrauto: [],
      vendorarrauto: [],categoryId: "",
selectedCategory: null,paymentMode: "",
categoryarrauto: [],
      reportData: [],
      selectedMode: "",  
	  modearrauto: [
    { id: 1, title: "Cash" },
    { id: 2, title: "Bank Transfer" },
    { id: 3, title: "UPI" },
    { id: 4, title: "Cheque" }
  ],
      ts_mode: "",
      page: 0,
      rowsPerPage:50,
      totalRecords: 0,
    };
  }
  modeMap = {
    1: "Cash",
    2: "Bank Transfer",
    3: "UPI",
    4: "Cheque"
  };
     getProjectIdFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("projectid");
  
  
};
 getProjectIdFromURL1 = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("vmid");
  
  
};
  componentDidMount() {
	 	if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Payments Out Report";   
			 this.props.parentsCallback(
           strname
        );
       
        
const projectId = this.getProjectIdFromURL();
const vmid = this.getProjectIdFromURL1();

  if (projectId && vmid) {
    this.setState(
      { projectId,vendorId:vmid },
      () => {
       this.loadVendorById(vmid);
        this.loadProjectById(projectId); 
      }
    );
  } else {
    this.fetchReport();
  }
  }
  
    loadVendorById = (vmid) => {
  axios
    .get(Serverurl + "ajaxvendor.php", {
      params: {
        action: "getall",
        vm_id: vmid
      }
    })
    .then((res) => {
      const data = res.data?.[0];
 if (data) {
        this.setState({
          selectedVendor: {
            title: data.vm_vendorname,
            vm_id: data.vm_id
          }
        },()=>{ });
      }
    });
};
  
    loadProjectById = (projectId) => {
  axios
    .get(Serverurl + "ajaxprojects.php", {
      params: {
        action: "getall",
        pj_id: projectId
      }
    })
    .then((res) => {
		
      const data = res.data?.[0];

      if (data) {
        this.setState({
          selectedProject: {
            title: data.pj_projectname,
            pj_id: data.pj_id
          }
        },()=>{ this.fetchReport();});
      }
    });
};
onloadProjectBind = (event, value) => {
const q = typeof value === "string" ? value : (event && event.target ? event.target.value : "");
axios
.get(
Serverurl +
"ajaxprojects.php?action=getallprojectautoextender&projectname=" +
encodeURIComponent(q)
)
.then((res) => {
const list = (res.data || []).map((r) => ({
title: r.pj_projectname,
pj_id: r.pj_id
}));
this.setState({ projectarrauto: list });
})
.catch((err) => {
console.error("Project autocomplete error:", err);
this.setState({ projectarrauto: [] });
});
};

onloadVendorBind = (event, value) => {
const q = typeof value === "string" ? value : (event && event.target ? event.target.value : "");
const vType = this.state && this.state.vendorType ? this.state.vendorType : "";
axios
.get(
Serverurl +
"ajaxvendor.php?action=getallautoextender&vm_vendorname=" +
encodeURIComponent(q) +
"&vm_type=" +
encodeURIComponent(vType)
)
.then((res) => {
const list = (res.data || []).map((r) => ({
title: r.vm_vendorname,
vm_id: r.vm_id
}));
this.setState({ vendorarrauto: list });
})
.catch((err) => {
console.error("Vendor autocomplete error:", err);
this.setState({ vendorarrauto: [] });
});
};
   fetchReport = () => {
    axios
      .get(
        Serverurl +
          "ajaxtransactions.php?action=paymentoutreport" +
       "&projectid=" + this.state.projectId +
	   "&ts_status=" + this.state.status +
"&vendorid=" + this.state.vendorId +
"&categoryid=" + this.state.categoryId +
"&paymentmode=" + this.state.selectedMode +
"&fromdate=" + this.state.fromDate.format("YYYY-MM-DD") +
"&todate=" + this.state.toDate.format("YYYY-MM-DD")+
          "&StartIndex=" +
          this.state.page +
          "&PageSize=" +
          this.state.rowsPerPage
      )
      .then((res) => {
        this.setState({
          reportData: res.data || [],
          totalRecords: res.data?.[0]?.count || 0
        });
      });
  };
exportExcel = () => {
  const { reportData } = this.state;

  if (!reportData.length) {
    alert("No data to export");
    return;
  }

  const excelData = reportData.map((r) => ({
    Date: r.PaymentDate
      ? dayjs(r.PaymentDate).format("DD/MM/YYYY")
      : "",
    Project: r.ProjectName,
    Category: r.Category,
    Vendor: r.Particular,
    PaymentMode: r.PaymentMode,
    Amount: r.Amount
  }));

  const totalAmount = reportData.reduce(
    (sum, r) => sum + (parseFloat(r.Amount) || 0),
    0
  );

  excelData.push({
    Date: "",
    Project: "",
    Category: "",
    Vendor: "",
    PaymentMode: "TOTAL",
    Amount: totalAmount.toFixed(2)
  });

  const ws = XLSX.utils.json_to_sheet(excelData);
  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    wb,
    ws,
    "Payment Out Report"
  );

  const buffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array"
  });

  saveAs(
    new Blob([buffer]),
    "Payment_Out_Report.xlsx"
  );

  this.setState({
    openExportDialog: false
  });
};
downloadPDF = () => {
  const { reportData } = this.state;

  const doc = new jsPDF("l", "mm", "a4");

  doc.setFontSize(14);
  doc.text("Payment Out Report", 14, 15);

  const headers = [[
    "Date",
    "Project",
    "Category",
    "Vendor",
    "Payment Mode",
    "Amount"
  ]];

  const rows = reportData.map((r) => [
    r.PaymentDate
      ? dayjs(r.PaymentDate).format("DD/MM/YYYY")
      : "",
    r.ProjectName,
    r.Category,
    r.Particular,
    r.PaymentMode,
    Number(r.Amount || 0).toLocaleString("en-IN")
  ]);

  const totalAmount = reportData.reduce(
    (sum, r) => sum + (parseFloat(r.Amount) || 0),
    0
  );

  rows.push([
    "",
    "",
    "",
    "",
    "TOTAL",
    totalAmount.toLocaleString("en-IN")
  ]);

  autoTable(doc, {
    head: headers,
    body: rows,
    startY: 25
  });

  doc.save("Payment_Out_Report.pdf");

  this.setState({
    openExportDialog: false
  });
};
  render() {
    return (
   
        
 <React.Fragment>
              
                   
                       

                         <div className="searchmaster">
                            <ul>
                            
                                <li>
                <p>From Date</p>
                <p> <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
				  disableFuture className="inputcntlparent"
                    value={this.state.fromDate}
                    onChange={(v) => this.setState({ fromDate: v })}
					format="DD/MM/YYYY"
                  />
                </LocalizationProvider>   </p>
              </li>
              <li>
                <p>To Date</p>
                <p> <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker className="inputcntlparent"
				  disableFuture
                    value={this.state.toDate}
                    onChange={(v) => this.setState({ toDate: v })}
					format="DD/MM/YYYY"
                  />
                </LocalizationProvider> </p>
              </li>
			  <li>
				<p>Status</p>
				<p>
					<FormControl  className="stadrp">			   
					<Select
					  className="inputcntlparent"
					  size="small"
					  variant="outlined"
					  native
					  value={this.state.status}
					  onChange={(e) => this.setState({ status: e.target.value })}
					  name="status"
					  id="status"
					>
					  <option value="">Select</option>
					  <option value="1">Yet to be Claimed</option>
					  <option value="2">Already Claimed</option>
					</Select>
					</FormControl>
				</p>
		
			</li>		  
              <li>
                <p>Project</p>
                <p><Autocomplete className="inputcntlparent"
                  options={this.state.projectarrauto}
                  value={this.state.selectedProject}
                  onChange={(e, v) =>
                    this.setState({
                      selectedProject: v,
                      projectId: v?.pj_id || ""
                    })
                  }
                  getOptionLabel={(o) => o.title || ""}
                  renderInput={(params) => (
                    <TextField {...params} size="small" onChange={this.onloadProjectBind} />
                  )}
                /></p>
              </li>			
              <li>
                <p>Vendor</p>
               <p> <Autocomplete className="inputcntlparent"
                  options={this.state.vendorarrauto}
                  value={this.state.selectedVendor}
                  onChange={(e, v) =>
                    this.setState({
                      selectedVendor: v,
                      vendorId: v?.vm_id || ""
                    })
                  }
                  getOptionLabel={(o) => o.title || ""}
                  renderInput={(params) => (
                    <TextField {...params} size="small" onChange={this.onloadVendorBind} />
                  )}
                /></p>
              </li>
			    <li>
			   <p>Payment Mode</p>
			 <p> 
			 <RadioGroup
          row
          value={this.state.selectedMode}
         onChange={(e) =>
                      this.setState({
                        selectedMode:
                          e.target.value
                      })
                    }
        >
          <FormControlLabel value="1" control={<Radio />} label="Cash" />
          <FormControlLabel value="2" control={<Radio />} label="Bank Transfer" />
          <FormControlLabel value="3" control={<Radio />} label="UPI" />
		            <FormControlLabel value="4" control={<Radio />} label="Cheque" />
        </RadioGroup>
			 
			 </p></li>
              <li>
                <p>&nbsp;</p>
                  <p> <Button variant="contained" className="exportbtn" onClick={this.fetchReport} endIcon={<SearchIcon />}>
                     Search
                </Button>
<Button
  variant="contained"
className="exportbtn"
  onClick={() => this.setState({ openExportDialog: true })}
  sx={{ ml: 1 }}
>
  Export
</Button>   </p></li>
            </ul>
          </div>
           <TableContainer sx={{ mt: 3 }}>
            <Table>
             <TableHead>
  <TableRow>
    <TableCell>Date</TableCell>
    <TableCell>Project</TableCell>
    <TableCell>Category</TableCell>
    <TableCell>Vendor</TableCell>
    <TableCell>Mode Of Payment</TableCell>
    <TableCell align="right">Amount</TableCell>
  </TableRow>
</TableHead>
         <TableBody>
  {this.state.reportData.map((r, i) => (
    <TableRow key={i}>
      <TableCell>
        {dayjs(r.PaymentDate).format("DD/MM/YYYY")}
      </TableCell>

      <TableCell>
        {r.ProjectName}
      </TableCell>

      <TableCell>
        {r.Category}
      </TableCell>

      <TableCell>
        {r.Particular}
      </TableCell>

      <TableCell>
        {r.PaymentMode}
      </TableCell>

      <TableCell align="right">
        Rs. {parseFloat(r.Amount).toLocaleString("en-IN")}
      </TableCell>
    </TableRow>
  ))}
</TableBody>
            </Table>
            <TablePagination
			 rowsPerPageOptions={[50, 100, 150, 200, 250]}  
              component="div"
              count={this.state.totalRecords}
              page={this.state.page}
              onPageChange={(e, p) =>
                this.setState({ page: p }, this.fetchReport)
              }
              rowsPerPage={this.state.rowsPerPage}
              onRowsPerPageChange={(e) =>
                this.setState(
                  {
                    rowsPerPage: parseInt(e.target.value, 10),
                    page: 0
                  },
                  this.fetchReport
                )
              }
            />
			<Dialog
  open={this.state.openExportDialog}
  onClose={() => this.setState({ openExportDialog: false })}
>
  <DialogTitle>Export Payment Out Report</DialogTitle>
  <DialogContent>
    <div style={{ display: "flex", gap: 15, justifyContent: "center", marginTop: 10 }}>
      <Button
        variant="contained"
        onClick={this.exportExcel}
        sx={{ backgroundColor: "#2e7d32" }}
      >
        Excel
      </Button>
      <Button
        variant="contained"
        onClick={this.downloadPDF}
        sx={{ backgroundColor: "#d32f2f" }}
      >
        PDF
      </Button>
    </div>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => this.setState({ openExportDialog: false })}>
      Cancel
    </Button>
  </DialogActions>
</Dialog>
          </TableContainer>
      
      </React.Fragment>
    );
  }
}
